export default __webpack_public_path__ + "static/media/volume.374f2b89.svg";